const _excluded = ["title", "description", "action", "footer", "onLogout", "homeUrl", "illustrationType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import A from '@adsk/alloy-react-a';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import ErrorPage from '../ErrorPage';
const DefaultAction = _ref => {
  let {
    homeUrl
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(A, {
    href: homeUrl,
    style: theme.typography.heading2
  }, T.translate('GO_HOME'));
};
DefaultAction.defaultProps = {
  homeUrl: '/'
};
DefaultAction.propTypes = {
  homeUrl: PropTypes.string
};
/**
 * A PageNotFound component. Used to show a generic "page not found" error.
 * Can be used as a fallback for unknown routes for example.
 */
const PageNotFound = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
      title,
      description,
      action,
      footer,
      onLogout,
      homeUrl,
      illustrationType = ErrorPage.ILLUSTRATION_TYPES.SKYLINE_GREY
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  const {
    T
  } = useLocale(_ref4 => {
    let {
      locale
    } = _ref4;
    return require("../i18n/".concat(locale, ".json"));
  });
  const finalTitle = title || T.translate('PAGE_NOT_FOUND_TITLE');
  const finalDescription = description || T.translate('PAGE_NOT_FOUND_DESCRIPTION');
  const finalAction = action || /*#__PURE__*/React.createElement(DefaultAction, {
    homeUrl: homeUrl
  });
  const finalFooter = footer || T.translate('404_ERROR');
  return /*#__PURE__*/React.createElement(ErrorPage, _extends({
    onLogout: onLogout,
    ref: ref,
    title: finalTitle,
    illustrationType: illustrationType,
    description: finalDescription,
    action: finalAction,
    footer: finalFooter
  }, props));
});
PageNotFound.displayName = 'PageNotFound';
PageNotFound.propTypes = _objectSpread(_objectSpread({}, ErrorPage.propTypes), {}, {
  homeUrl: PropTypes.string
});
export default Object.assign(PageNotFound, {
  ILLUSTRATION_TYPES: ErrorPage.ILLUSTRATION_TYPES
});
//# sourceMappingURL=PageNotFound.js.map